import { useQuery } from '@apollo/client/react'
import { useMemo } from 'react'
import { get } from 'lodash'
import { GET_MERCHANT_DETAILS } from '../graphql/queries'
import { getCurrentMerchantID } from '../features/data'

export const useCurrentMerchant = () => {
	const { currentMerchantID } = getCurrentMerchantID()

	const { data, ...rest } = useQuery(GET_MERCHANT_DETAILS, {
		variables: {
			currentMerchantID,
		},
		skip: !currentMerchantID,
	})

	const refundPeriodDays = useMemo(() => get(data, 'merchant.refundPeriodDays'), [data])

	/**
	 * TODO
	 * expose merchant to be directly accessible like
	 * 	const { merchant } = useCurrentMerchant()
	 * 	instead of
	 * 	const { data: merchantData } = useCurrentMerchant()
	 *	const merchant = get(merchantData, 'merchant')
	 */
	return {
		refundPeriodDays,
		data,
		...rest,
	}
}
